module.exports = __webpack_public_path__ + "img/mines.eabbef79.webp";